import '@shui/core/sh-list';

import { Component, input, booleanAttribute, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'sh-list',
    template: '<ng-content />',
    imports: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    host: {
        '[attr.flat]': 'flat() ? "" : null',
        '[attr.integrated]': 'integrated() ? "" : null',
        '[attr.override]': 'override() ?? null',
        '[attr.selection-type]': 'selectionType() ?? null'
    }
})
export class ShListComponent {
    /** If set to `true`, the list will have no background color nor elevation applied to it. */
    public readonly flat = input(false, { transform: booleanAttribute });

    /** Defines the padding of the list items placed inside */
    public readonly integrated = input(false, { transform: booleanAttribute });

    public readonly override = input<string | number | undefined>(undefined);

    /**
     * Defines the selectable state of the list items. Possible values are `multiple` and `single`
     */
    public readonly selectionType = input<string | number | undefined>(undefined);
}
